import { useAuth } from '@polvo-labs/react-auth'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import routes from '../../config/routes'
import isCommon from '../../utils/is-common'
import Avatar from '../Avatar'
import Button from '../Button'
import Icon from '../Icon'
import Logout from '../Logout'
import Popover from '../Popover'
import { Actions, Container, LogoWithoutImage, MobileToggle, OutherMenuContent } from './styles'

interface Props {
  position?: 'absolute' | 'fixed' | 'sticky'
  withoutLogo?: boolean
  right?: boolean
  noBurgerOnMobile?: boolean
  outerMenu?: React.ReactNode
}

const Header: React.FC<Props> = ({
  withoutLogo = false,
  noBurgerOnMobile = false,
  right = false,
  children,
  outerMenu,
}) => {
  const history = useHistory()
  const { user, authenticated } = useAuth()
  const [open, setOpen] = useState(false)
  const [userMenuOpened, setUserMenuOpened] = useState(false)

  useEffect(() => {
    let mounted = true
    history.listen(() => {
      if (mounted)
        setOpen(false)
    })
    return () => {
      mounted = false
    }
  }, [history])
  return (
    <Container
      right={right}
    >
      {!withoutLogo && (
        <LogoWithoutImage
          to={routes.index.path}
        >
          IPTU
        </LogoWithoutImage>
      )}
      <OutherMenuContent>
        {outerMenu}
      </OutherMenuContent>
      <MobileToggle
        noBurgerOnMobile={noBurgerOnMobile}
        label={(
          <Icon
            name="menu"
          />
        )}
        backgroundColor="transparent"
        onClick={() => setOpen(prev => !prev)}
      />

      <Actions
        open={open}
        noBurgerOnMobile={noBurgerOnMobile}
      >
        <MobileToggle
          noBurgerOnMobile={noBurgerOnMobile}
          label={(
            <Icon
              name="menu"
            />
          )}
          backgroundColor="transparent"
          onClick={() => setOpen(prev => !prev)}
        />

        {children}
        {/* {authenticated && user && !user.verified && (
          <Button
            before={(
              <Icon
                name="account"
              />
            )}
            label="Mudar de conta"
            backgroundColor="green"
            onClick={() => {
              setTimeout(() => {
                request({
                  method: 'DELETE',
                  url: `${process.env.REACT_APP_API_URL}/sessions/${user.current_session.id}`,
                }).then(() => {
                  toast.success('Deslogado com sucesso')
                  window.localStorage.clear()
                  logout!()
                  history.push(routes.login.path)
                })
              }, 0)
            }}
          />
        )} */}
        {authenticated && user && (
          <Popover
            open={userMenuOpened}
            button={{
              before: (
                <Avatar
                  img={user.avatar?.tiny || 'https://cdn.iptu.app/assets/img/person/placeholder.png'}
                />
              ),
              after: (
                <Icon
                  name="caret"
                />
              ),
              label: (
                <span
                  style={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    maxWidth: '200px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {user.name}
                </span>
              ),
              backgroundColor: 'transparent',
              fontColor: 'darkGray',
              smallPadding: true,
            }}
            onChange={open => setUserMenuOpened(open)}
          >
            {!isCommon(user) && (
              <Button
                before={(
                  <Icon
                    name="admin"
                  />
                )}
                label="Admin"
                backgroundColor="transparent"
                fontColor="darkGray"
                alignText="flex-start"
                onClick={() => {
                  history.push(routes.admin.index.path)
                  setUserMenuOpened(false)
                }}
              />
            )}
            {isCommon(user) && (
              <Button
                before={(
                  <Icon
                    name="house"
                  />
                )}
                label="Meus Imóveis"
                backgroundColor="transparent"
                fontColor="darkGray"
                alignText="flex-start"
                onClick={() => {
                  history.push(routes.realty.index.path)
                  setUserMenuOpened(false)
                }}
              />
            )}
            <Button
              before={(
                <Icon
                  name="settings"
                />
              )}
              label="Ajustes"
              backgroundColor="transparent"
              fontColor="darkGray"
              alignText="flex-start"
              onClick={() => {
                history.push(routes.settings.index.path)
                setUserMenuOpened(false)
              }}
            />
            <Logout />
          </Popover>
        )}
      </Actions>
    </Container>
  )
}

export default Header
